export var DistributionKind;
(function (DistributionKind) {
    DistributionKind["DISTRIBUTION_KIND_UNSPECIFIED"] = "DISTRIBUTION_KIND_UNSPECIFIED";
    DistributionKind["DISTRIBUTION_KIND_NUMERIC"] = "DISTRIBUTION_KIND_NUMERIC";
    DistributionKind["DISTRIBUTION_KIND_ENUM"] = "DISTRIBUTION_KIND_ENUM";
})(DistributionKind || (DistributionKind = {}));
